import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const RepliesShow = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6464 6.35355C10.8417 6.54882 11.1583 6.54882 11.3536 6.35355C11.5488 6.15829 11.5488 5.84171 11.3536 5.64645L8.35355 2.64645C8.15829 2.45118 7.84171 2.45118 7.64645 2.64645L4.64645 5.64645C4.45118 5.84171 4.45118 6.15829 4.64645 6.35355C4.84171 6.54882 5.15829 6.54882 5.35355 6.35355L8 3.70711L10.6464 6.35355ZM5.35355 9.64645C5.15829 9.45118 4.84171 9.45118 4.64645 9.64645C4.45118 9.84171 4.45118 10.1583 4.64645 10.3536L7.64645 13.3536C7.84171 13.5488 8.15829 13.5488 8.35355 13.3536L11.3536 10.3536C11.5488 10.1583 11.5488 9.84171 11.3536 9.64645C11.1583 9.45118 10.8417 9.45118 10.6464 9.64645L8 12.2929L5.35355 9.64645Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default RepliesShow
